import { ActionTypes } from "./../actions/index";
import { CobrowseState } from "../states";
import { CobrowseStateEnum } from "../../models";
import { CobrowseActions } from "../actions/cobrowse";
import { CobrowsePermissionEnum } from "../../models/enums";

const getInitialState = (): CobrowseState => {
  return {
    state: CobrowseStateEnum.idle,
    origin: null,
    sessionMetadata: {},
    remoteEndpointMetadata: {},
    ticket: null,
    requestType: null,
    permissions: {
      [CobrowsePermissionEnum.view]: false,
      [CobrowsePermissionEnum.control]: false,
      [CobrowsePermissionEnum.displayCapture]: false,
    },
  };
};

const cobrowse = (
  state = getInitialState(),
  action: ActionTypes
): CobrowseState => {
  switch (action.type) {
    case CobrowseActions.COBROWSE_RESET:
      return getInitialState();
    case CobrowseActions.COBROWSE_STATE_CHANGE:
      return {
        ...state,
        state: action.payload,
      };
    case CobrowseActions.COBROWSE_ORIGIN_CHANGE:
      return { ...state, origin: action.payload };
    case CobrowseActions.COBROWSE_REMOTE_ENDPOINT_METADATA_CHANGE:
      return { ...state, remoteEndpointMetadata: action.payload };
    case CobrowseActions.COBROWSE_METADATA_CHANGE:
      return {
        ...state,
        sessionMetadata: {
          ...state.sessionMetadata,
          [action.payload.key]: action.payload,
        },
      };
    case CobrowseActions.COBROWSE_TICKET_CHANGE:
      return { ...state, ticket: action.payload };
    case CobrowseActions.COBROWSE_PERMISSION_CHANGE:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...action.payload,
        },
      };
    case CobrowseActions.COBROWSE_REQUEST_TYPE_CHANGE:
      return { ...state, requestType: action.payload };
  }
  return state;
};

export default cobrowse;
